import { api } from '@marketplace-web/core-api/core-api-client-util'

import { GetPrivacyPolicyResp } from '../types/privacy-policy'

export const getPrivacyPolicy = () => api.get<GetPrivacyPolicyResp>('/privacy_policy')
